import { Injectable } from '@angular/core';
import { environment } from '@app/../environments/environment';
import { createClient, SupabaseClient } from '@supabase/supabase-js';

export interface Profile {
    id?: string;
    username: string;
    website: string;
    avatar_url: string;
}

@Injectable({
    providedIn: 'root'
})
export class SupabaseService {
    private supabase: SupabaseClient;

    constructor() {
        this.supabase = createClient(environment.supabaseUrl, environment.supabaseKey);
    }

    public async signIn(email: string, password: string) {
        const response: any = await this.supabase.auth.signIn({ email, password });
        const data = {
            ...response.data.user.app_metadata,
            access_token: response.data.access_token,
            email: response.data.user.email
        };
        return data;
    }

    public signOut() {
        return this.supabase.auth.signOut();
    }
}
